// extracted by mini-css-extract-plugin
export default {"modal":"TP-z","addItemButton":"UP-z","plusCircle":"VP-z","branchVisible":"WP-z"};